Vue.component("portfolio", {

    props: ["portfolio", "users"],

    data () {
        return {
            isEditing: false,
            setAsDefault: false,
            usersInPortfolio: [],
            usersNotInPortfolio: [],
            form: new AppForm({})
        };
    },

    mounted () {
        let self = this;

        Bus.$on("portfolio-selected", function (portfolioId) {
            if (self.portfolio.id !== portfolioId) {
                self.isEditing = false;
                self.hideUserSelectDropdown();
            }
        });

        Bus.$on("default-changed", function (defaultPortfolioId) {
            if (self.portfolio.default && self.portfolio.id !== defaultPortfolioId) {
                self.portfolio.default = false;
                self.setAsDefault = self.portfolio.default;
            }
        });

        this.form.portfolio_name = this.portfolio.name;
        this.setAsDefault = this.portfolio.default;
        this.loadPortfolioUsers();
    },

    methods: {
        loadPortfolioUsers () {
            this.usersNotInPortfolio = this.findUsersNotInPortfolio();
            this.usersInPortfolio = this.portfolio.users;
        },

        findUsersNotInPortfolio () {
            if (this.portfolio.users) {

                let self = this;
                return this.users.filter(function (user) {
                    return !self.portfolio.users.find(function (portfolioUser) {
                        return portfolioUser.id === user.id;
                    });
                });
            }

            return this.users;
        },

        savePortfolio () {
            if (this.setAsDefault) {
                this.form.default_portfolio = this.setAsDefault;
            }

            App.patch("/settings/portfolios/" + this.portfolio.id + "/update", this.form)
            .then(() => {
                if (this.portfolio.default !== this.setAsDefault) {
                    Bus.$emit("default-changed", this.portfolio.id);
                }
                this.portfolio.name = this.form.portfolio_name;
                this.portfolio.default = this.setAsDefault;

                this.form.errors.forget();
                toastr.success("Portfolio saved!");
            });
        },

        deletePortfolio () {
            App.delete("/settings/portfolios/" + this.portfolio.id, this.form)
            .then(() => {
                Bus.$emit("portfolio-deleted", this.portfolio);
                toastr.success("Portfolio deleted!");
            })
            .catch((error) => {
                toastr.error(error);
            });
        },

        makeDefault () {
            swal({
                title: "Make " + this.portfolio.name + " the default portfolio.",
                text: "New assets will be linked to this portfolio by default.",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    this.setAsDefault = true;
                    this.savePortfolio();
                }
            });
        },

        showDeleteConfirmation () {
            if (this.portfolio.default) {
                toastr.info("Can't delete the default portfolio!");
                return;
            }

            let self = this;
            swal({
                title: "Delete Portfolio",
                text: "All assets linked to this portfolio will be moved to the default portfolio.",
                input: "text",
                inputPlaceholder: "Enter portfolio name to confirm",
                showCancelButton: true,
                inputValidator: (value) => {

                    if (value !== this.portfolio.name) {
                        return "That's not the name of this portfolio";
                    }

                    return !value && "You need to write something!";
                }
            }).then((result) => {
                if (result.value) {
                    self.deletePortfolio();
                }
            });
        },

        addUser (user) {
            App.post("/settings/portfolios/" + this.portfolio.id + "/users/" + user.id + "/add", new AppForm({}))
            .then(() => {
                toastr.success(user.name + " added to " + this.portfolio.name);
                this.portfolio.users.push(user);
                this.loadPortfolioUsers();
                if (!this.isEditing) {
                    this.isEditing = true;
                }
            });
        },

        removeUser (user) {
            App.post("/settings/portfolios/" + this.portfolio.id + "/users/" + user.id + "/remove", new AppForm({}))
            .then(() => {
                toastr.success(user.name + " removed from " + this.portfolio.name);

                this.portfolio.users = this.portfolio.users.filter(function (item) {
                    return item.id !== user.id;
                });

                this.loadPortfolioUsers();
            });
        },

        toggleEditing () {
            this.isEditing = !this.isEditing;

            if (this.isEditing) {
                Bus.$emit("portfolio-selected", this.portfolio.id);
            }
        },

        toggleUserSelectDropdown () {
            $("#userSelectDropdown-" + this.portfolio.id).toggle();
        },

        hideUserSelectDropdown () {
            $("#userSelectDropdown-" + this.portfolio.id).hide();
        }
    }

});